<template>
  <div class="home-goods">
    <div class="content">
      <van-row gutter="10"  style="display: flex;flex-wrap: wrap;">
        <van-col span="12" v-for="item in productList" :key="item.id" @click="onNavigate(item)" v-if="productList.length > 0">
          <div class="item">
            <img :src="item.image" alt="goods03" width="170" height="170">
            <div class="content">
              <div class="name">{{item.name}}</div>
              <div class="footer">
                <span class="price">￥{{item.price}}</span>
                <img src="@/assets/mycart.png" alt="加入购物车" width="30" height="30" @click.stop="onAddCartClicked(item.id)">
              </div>
            </div>
          </div>
        </van-col>
      </van-row>
      <empty  v-if="productList.length == 0"/>
    </div>
  </div>
</template>

<script>
import { addShopCart } from '@/api/cart'
export default {
  name: 'Goods',
  props: {
    productList: {
      type: Array
    }
  },
  methods: {
    onNavigate(item) {
      this.$router.push({
        path: '/product/detail',
        query: { id: item.id }
      })
    },
    onAddCartClicked(id) {
      var user = JSON.parse(localStorage.getItem('userInfo'))
      if (!user) {
        this.$router.push({ path: '/login' })
        return;
      }
      const form = {
        uid: user.id,
        pid: id,
        number: 1
      }
      addShopCart(form).then(res => {
        if (res.success) {
          this.$toast({
            message: '已添加至购物车',
            duration: 1500
          })
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
  .home-goods{
    padding: 0 12px;
    .title{
      height:28px;
      font-size:20px;
      font-weight:bold;
      line-height:28px;
      color:rgba(51,51,51,1);
    }
    .content{
      padding: 10px 0;
      .item{
        border:1px solid rgba(243,243,243,1);
        .name{
          overflow:hidden;/*超出隐藏*/
          text-overflow:ellipsis;/*文本溢出时显示省略标记*/
          display:-webkit-box;/*设置弹性盒模型*/
          -webkit-line-clamp:2;/*文本占的行数,如果要设置2行加...则设置为2*/
          -webkit-box-orient:vertical;/*子代元素垂直显示*/
          font-size:14px;
          font-weight:bold;
          line-height:17px;
          color:rgba(51,51,51,1);
          opacity:1;
          margin-bottom: 10px;
        }
        .footer{
          display: flex;
          justify-content: space-between;
          .price{
            height:30px;
            font-size:16px;
            font-weight:bold;
            line-height:30px;
            color:rgba(254,0,59,1);
          }
        }
      }
    }

  }
</style>



// WEBPACK FOOTER //
// src/views/matter/modules/Goods.vue